import { connect } from "react-redux"
import { reduxForm } from "redux-form/immutable"
import { fromJS } from "immutable"

// form component
import BulkActionsConsole from "app/static/frontend/search-new/components/BulkActions/BulkActionsConsole"

// form
import { BULK_ACTIONS_FORM_KEY } from "shared/imports/sharedConstants"
import {
    validate,
    onSubmit,
    onSubmitSuccess,
    onSubmitFail,
} from "shared/forms/BulkActions/action-creators"

// search action creators
import {
    setActiveActionButton,
    triggerDataRefresh
} from "shared/search/action-creators"

// bulk action action creators
import {
    clearBulkActionsSlice,
    createBulkAction,
    disableBulkActionsMode,
    initializeBulkActionsSlice,
} from "shared/search/searchify/bulkactions/action-creators"

// bulk action selectors
import {
    selectBulkActionsAddedIds,
    selectBulkActionsBulkActionType,
    selectBulkActionsCount,
    selectBulkActionsDeletedIds,
    selectBulkActionsValidOptions,
} from "shared/search/searchify/bulkactions/selectors"

// search selectors
import {
    selectAllActiveDeserializedFilters,
    selectCurrentCount
} from "shared/search/selectors"

// other selectors
import { selectSearchIsTableView } from "shared/userdata/userdata-selectors"
import { selectCustomFieldNameDict } from "shared/customFields/selectors"

const mapStateToProps = (state, props) => ({
    addedIds: selectBulkActionsAddedIds(state, props),
    bulkActionType: selectBulkActionsBulkActionType(state, props),
    bulkActionValidOptions: selectBulkActionsValidOptions(state, props),
    bulkActionsCount: selectBulkActionsCount(state, props),
    currentCount: selectCurrentCount(state, props),
    customFieldNameDict: selectCustomFieldNameDict(props.quorumDataType)(state, props),
    deletedIds: selectBulkActionsDeletedIds(state, props),
    filters: selectAllActiveDeserializedFilters(state, props),
    isTableView: selectSearchIsTableView(state, props),
})

const mapDispatchToProps = {
    clearBulkActionsSlice,
    createBulkAction,
    disableBulkActionsMode,
    initializeBulkActionsSlice,
    setActiveActionButton,
    triggerDataRefresh,
}

const bulkActionsForm = reduxForm({
    form: BULK_ACTIONS_FORM_KEY,
    destroyOnUnmount: false,
    enableReinitialize: true,
    initialValues: fromJS({
        // default for BulkActionsApprove
        approve: true,
        // default for BulkActionsArchive
        archive: true,
        // default for BulkActionsAssign
        assignment_input_type: DjangIO.app.search.bulkactions.types.AssignmentInputType.user.value,
        assignment_select_type: DjangIO.app.search.bulkactions.types.AssignmentSelectType.add.value,
        // default for BulkActionsCustomField
        custom_field_type: DjangIO.app.search.bulkactions.types.CustomFieldSelectType.add.value,
        // default for BulkActionsExternalContact
        external_contact: DjangIO.app.search.bulkactions.types.ExternalContactType.show.value,
        // default for BulkActionsIssue
        issue_type: DjangIO.app.search.bulkactions.types.IssueSelectType.add.value,
        // default for BulkActionsOrganization
        organization_select_type: DjangIO.app.search.bulkactions.types.OrganizationSelectType.add.value,
        // default for BulkActionsTeam
        team_type: DjangIO.app.search.bulkactions.types.TeamSelectType.limit.value,
        // default for BulkActionsUnsuppress
        valid_email: true,
    }),
    keepDirtyOnReinitialize: true,
    // https://github.com/erikras/redux-form/issues/3276#issuecomment-378996666
    shouldError: ({
        values,
        nextProps,
        props,
        initialRender,
        lastFieldValidatorKeys,
        fieldValidatorKeys,
        structure,
    }) => {
        if (initialRender) {
            return true
        }

        return (
            !structure.deepEqual(values, nextProps.values) ||
            !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys) ||
            props.registeredFields !== nextProps.registeredFields
        )
    },
    touchOnChange: true,
    touchOnBlur: true,
    validate,
    onSubmit,
    onSubmitSuccess,
    onSubmitFail,
})(BulkActionsConsole)

export default connect(mapStateToProps, mapDispatchToProps)(bulkActionsForm)
